/** Preset reasons for a DICOM tag edit; 'other' asks for free text. The translated label is what the audit log keeps. */
export const DICOM_EDIT_REASONS = [
    'miskeyed',
    'wrongPatient',
    'correction',
    'viewLabel',
    'positioning',
    'other',
];
export const DICOM_EDIT_REASON_MAX_LENGTH = 500;
